import React from 'react';
import clsx from 'clsx';

import {
  FUTURE_MILESTONES_HEADING_TEST_ID,
  FUTURE_MILESTONES_NAME_TEST_ID,
  FUTURE_MILESTONES_TEST_ID,
} from './FutureMilestones.test-ids';

import styles from './FutureMilestones.module.scss';

interface FutureMilestonesProps {
  milestones: string[];
  heading?: string;
  hasNext?: boolean;
}

const FutureMilestones: React.FC<FutureMilestonesProps> = ({ milestones, heading, hasNext = true }) => {
  if (!milestones.length) return null;
  const futureMilestoneClassname = clsx(styles.futureMilestone, !hasNext && styles.endTramStop);
  const displayFutureMilestones = () => {
    return milestones.map((milestone, index) => (
      <React.Fragment key={index}>
        <div className={styles.nameWrapper}>
          <span className={styles.stop} />
          <p className={styles.name} data-testid={FUTURE_MILESTONES_NAME_TEST_ID}>
            <span className='sr-only'>Future milestone:&nbsp;</span>
            {milestone}
          </p>
        </div>
        {(index < milestones.length - 1 || hasNext) && <div className={styles.divider} />}
      </React.Fragment>
    ));
  };
  return (
    <div className={futureMilestoneClassname} data-testid={FUTURE_MILESTONES_TEST_ID}>
      <div className={styles.tramTrack} />
      {heading && (
        <p className={styles.subtitle} data-testid={FUTURE_MILESTONES_HEADING_TEST_ID}>
          {heading}
        </p>
      )}
      {displayFutureMilestones()}
    </div>
  );
};

export default FutureMilestones;
